import Axios from "axios";
import { getServiceUrl } from "config";

export const serviceInstance = Axios.create({
  baseURL: getServiceUrl(),
});
